module.exports = __webpack_public_path__ + "img/HC1023-154.1222b86a.jpg";